<div class="modal-header">
	<h4 class="modal-title">Simulação de renumeração</h4>
	<button type="button" class="btn-close" aria-label="Fechar" (click)="close()"></button>
</div>

<div class="modal-body">
	@if (run?.active) {
		<p class="mb-2">{{ run.progressLabel }}</p>
		<div class="progress mb-3" role="progressbar" [attr.aria-valuenow]="run.percent" aria-valuemin="0" aria-valuemax="100">
			<div class="progress-bar progress-bar-striped progress-bar-animated" [style.width.%]="run.percent || 5"></div>
		</div>
		<p class="text-muted small mb-0">
			Nada muda enquanto a simulação roda: o processo continua publicado, com a paginação atual. Você pode fechar esta janela; o resultado fica no
			histórico de paginação e você recebe um aviso quando terminar.
		</p>
	} @else if (run?.status === Status.SIMULATED) {
		<div class="d-flex flex-wrap gap-3 mb-3">
			<div>
				<div class="text-muted small">Folhas hoje</div>
				<div class="fs-4 fw-700">{{ run.pagesBefore ?? 0 }}</div>
			</div>
			<div class="align-self-center text-muted"><fa-icon icon="arrow-right"></fa-icon></div>
			<div>
				<div class="text-muted small">Folhas depois</div>
				<div class="fs-4 fw-700">{{ run.pagesAfter ?? 0 }}</div>
			</div>
			<div class="ms-auto text-end small text-muted align-self-end">
				{{ run.changes?.length ?? 0 }} arquivo(s) mudam de folha
				@if (run.expiresAt) {
					<div>Pode ser aplicada até {{ run.expiresAt | date: "dd/MM/yyyy 'às' HH:mm" }}</div>
				}
			</div>
		</div>
		<app-electronic-process-pagination-changes [changes]="run.changes"></app-electronic-process-pagination-changes>
		<p class="text-muted small mt-3 mb-0">
			A aplicação usa esta contagem, sem contar de novo, e só é aceita se o processo não mudou desde a simulação (documentos, ordem, arquivos e anexos).
			Fora disso, simule novamente.
		</p>
		@if (applyBlockedReason) {
			<div class="alert alert-warning small mt-3 mb-0">{{ applyBlockedReason }}</div>
		}
	} @else if (unchanged) {
		<div class="alert alert-success mb-0">
			<fa-icon icon="circle-check" class="me-2"></fa-icon>
			Nenhuma folha muda: a paginação está correta e não há o que aplicar.
		</div>
	} @else if (run?.failed) {
		<div class="alert alert-danger">
			<p class="fw-600 mb-2">A simulação não pôde contar todos os arquivos. A paginação atual continua valendo.</p>
			<app-electronic-process-pagination-failures [failure]="run.error"></app-electronic-process-pagination-failures>
		</div>
		<p class="text-muted small mb-0">Corrija os documentos apontados e reprocesse a paginação de novo.</p>
	} @else if (run?.status === Status.APPLIED) {
		<div class="alert alert-success mb-0">Esta simulação já foi aplicada.</div>
	} @else {
		<div class="alert alert-secondary mb-0">Esta simulação foi substituída ou venceu. Reprocesse a paginação para simular de novo.</div>
	}
</div>

<div class="modal-footer">
	@if (run?.status === Status.SIMULATED) {
		<button type="button" class="btn btn-link" (click)="close()">Fechar sem aplicar</button>
		<button
			*permissions="'planning.electronic-process.manage'"
			type="button"
			class="btn btn-primary fw-700"
			[disabled]="applying || !run.applicable || !!applyBlockedReason"
			(click)="apply()">
			{{ applying ? 'Aplicando...' : 'Aplicar renumeração' }}
		</button>
	} @else {
		<button type="button" class="btn btn-primary" (click)="close()">Fechar</button>
	}
</div>
